import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useAuth from 'hooks/useAuth'
import { LocalAuthStorageKey } from 'types'

export default function useSessionTimeout(limitMs: number): void {
  const location = useLocation()
  const { profile } = useAuth()

  const effectiveLimit: number = limitMs

  const skipRoutes: string[] = [
    '/session-expired-verify-email',
    '/session-expired-otp-verify'
  ]

  const shouldSkip: boolean = skipRoutes.includes(location.pathname)

  useEffect(() => {
    if (shouldSkip) return

    const updateActivity = () => {
      if (profile) {
        localStorage.setItem('last_activity', Date.now().toString())
      }
    }

    window.addEventListener('click', updateActivity)
    window.addEventListener('keypress', updateActivity)
    window.addEventListener('scroll', updateActivity)

    return () => {
      window.removeEventListener('click', updateActivity)
      window.removeEventListener('keypress', updateActivity)
      window.removeEventListener('scroll', updateActivity)
    }
  }, [shouldSkip, profile])

  useEffect(() => {
    if (shouldSkip) return

    const checkTimeout = () => {
      const lastRaw = localStorage.getItem('last_activity')
      if (!lastRaw) return

      const last = Number(lastRaw)
      if (!last) return

      const diff = Date.now() - last
      if (diff >= effectiveLimit) {
        const currentPath = window.location.href
        localStorage.setItem(
          LocalAuthStorageKey.PREVIOUS_SESSION_EXPIRED_PATH,
          currentPath
        )
        window.location.href = '/session-expired-verify-email'
      }
    }

    checkTimeout()

    const interval = window.setInterval(checkTimeout, 5000)

    return () => clearInterval(interval)
  }, [shouldSkip, effectiveLimit])
}
